import type { Shift } from '../../../../../core/models/data';
import type { SchedulerRefreshReason } from './schedulerRefreshController';

export const SOFT_SCHEDULER_REFRESH_REASONS = new Set<SchedulerRefreshReason>([
  'poll',
  'post_mutation',
  'tab_focus',
  'visibility_return',
  'week_change',
]);

export type SchedulerRefreshResponseDecision =
  | {
      action: 'apply';
      warningMessage: null;
    }
  | {
      action: 'ignore_stale_empty_soft_response';
      warningMessage: string;
    }
  | {
      action: 'ignore_old_sequence_response';
      warningMessage: null;
    };

export const SCHEDULER_STALE_EMPTY_REFRESH_WARNING =
  'A beosztás frissítése nem írta felül az aktuális nézetet, mert a szerverválasz üres volt.';

export const isSoftSchedulerRefreshReason = (reason: SchedulerRefreshReason): boolean =>
  SOFT_SCHEDULER_REFRESH_REASONS.has(reason);

export const resolveSchedulerRefreshResponseDecision = (params: {
  reason: SchedulerRefreshReason;
  previousVisibleShifts: Shift[];
  apiShifts: Shift[];
  hasHydratedOnce: boolean;
  requestSequence: number;
  latestStartedSequence: number;
}): SchedulerRefreshResponseDecision => {
  if (params.requestSequence < params.latestStartedSequence) {
    return {
      action: 'ignore_old_sequence_response',
      warningMessage: null,
    };
  }

  if (
    params.hasHydratedOnce &&
    isSoftSchedulerRefreshReason(params.reason) &&
    params.previousVisibleShifts.length > 0 &&
    params.apiShifts.length === 0
  ) {
    return {
      action: 'ignore_stale_empty_soft_response',
      warningMessage: SCHEDULER_STALE_EMPTY_REFRESH_WARNING,
    };
  }

  return {
    action: 'apply',
    warningMessage: null,
  };
};
